export const FullLoading = ()=>{
  return (
    <div className="full-loading">
      <span className="loader"></span>
    </div>
  );
};
